import css from "styled-jsx/css";

export const componentStyles = css.global`
  .paragraph-body {
    font-size: 20px;
    line-height: 32px;
    margin: 0; //overide h3 global definition
    word-break: break-word;

    &.md {
      font-size: 20px;
      line-height: 32px;
    }

    &.lg {
      font-size: 24px;
      line-height: 40px;
    }
  }
`;
